import {
	getDownwardEquilateralTrianglePoints,
	getUpwardEquilateralTrianglePoints,
} from "./marks";

interface Props {
	toggleIndicator: {
		ask: boolean;
		bid: boolean;
		trades: boolean;
		primaryRound: boolean;
		askRef: boolean;
	};
	onChange: React.ChangeEventHandler;
	isAskGraph: boolean;
	showFundingSeries: boolean;
}

const Toggle = ({
	toggleIndicator,
	onChange,
	isAskGraph,
	showFundingSeries,
}: Props) => {
	if (isAskGraph) {
		return (
			<div
				className="inline-flex flex-wrap gap-x-8 gap-y-4 md:justify-normal"
				role="group"
			>
				<label className="inline-flex items-center cursor-pointer">
					<input
						type="checkbox"
						checked={toggleIndicator.bid}
						className="sr-only peer"
						name="toggle-bid"
						onChange={onChange}
					/>
					<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
					<UpwardTriangle text="Bid" />
				</label>

				<label className="inline-flex items-center cursor-default">
					<input
						type="checkbox"
						checked={toggleIndicator.ask}
						className="sr-only peer"
						name="toggle-ask"
						onChange={onChange}
						disabled
					/>
					<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
					<DownwardTriangle text="Ask" />
				</label>

				<label className="inline-flex items-center cursor-pointer">
					<input
						type="checkbox"
						checked={toggleIndicator.trades}
						className="sr-only peer"
						name="toggle-closed-trades"
						onChange={onChange}
					/>
					<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
					<Trade text="Closed trades" />
				</label>

				<label className="inline-flex items-center cursor-pointer gap-2">
					<input
						type="checkbox"
						checked={toggleIndicator.askRef}
						className="sr-only peer"
						name="toggle-ask-ref"
						onChange={onChange}
					/>
					<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
					<AskRefCircle text="Reference price (Ext.)" />
				</label>

				{showFundingSeries && (
					<label className="inline-flex items-center cursor-pointer gap-2">
						<input
							type="checkbox"
							checked={toggleIndicator.primaryRound}
							className="sr-only peer"
							name="toggle-primary-round"
							onChange={onChange}
						/>
						<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
						<DashedLine text="Primary round pricing" />
					</label>
				)}
			</div>
		);
	}
	return (
		<div
			className="inline-flex flex-wrap gap-x-8 gap-y-4 mt-4 md:justify-normal"
			role="group"
		>
			<label className="inline-flex items-center cursor-default">
				<input
					type="checkbox"
					checked={toggleIndicator.trades}
					className="sr-only peer"
					name="toggle-closed-trades"
					onChange={onChange}
					disabled
				/>
				<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
				<Circle text="Last traded" />
			</label>

			<label className="inline-flex items-center cursor-pointer">
				<input
					type="checkbox"
					checked={toggleIndicator.ask}
					className="sr-only peer"
					name="toggle-ask"
					onChange={onChange}
				/>
				<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
				<DownwardTriangle text="Ask" />
			</label>

			<label className="inline-flex items-center cursor-pointer">
				<input
					type="checkbox"
					checked={toggleIndicator.bid}
					className="sr-only peer"
					name="toggle-bid"
					onChange={onChange}
				/>
				<div className="relative w-8 h-4 bg-gray-200 peer-focus:outline-none peer-focus:ring-1 peer-focus:ring-green-300 dark:peer-focus:ring-green-300 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[0px] after:start-[0px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-alta-light-green" />
				<UpwardTriangle text="Bid" />
			</label>
		</div>
	);
};

export default Toggle;

const Circle = ({ text }: { text: string }) => {
	return (
		<span className="ms-1 text-xs md:text-sm font-semibold text-gray-600 dark:text-gray-600 inline-flex items-center gap-2">
			<svg height={20} width={20}>
			<line
					y1="10"
					x1="0"
					x2="28"
					y2="10"
					stroke="#175963"
					strokeWidth="2"
				/>
				<circle
					cy={10}
					cx={10}
					r={2.5}
					fill="white"
					stroke={"#175963"}
					strokeWidth="2"
				/>
			</svg>
			{text}
		</span>
	);
};
const UpwardTriangle = ({ text }: { text: string }) => {
	return (
		<span className="ms-1 text-xs md:text-sm font-semibold text-gray-600 dark:text-gray-600 inline-flex items-center">
			<svg height={20} width={20}>
				<polygon
					transform="translate(5,5.5)"
					points={getUpwardEquilateralTrianglePoints()}
					fill="white"
					stroke="#249567"
					strokeWidth="1.5"
				/>
			</svg>
			{text}
		</span>
	);
};
const DownwardTriangle = ({ text }: { text: string }) => {
	return (
		<span className="ms-1 text-xs md:text-sm font-semibold text-gray-600 dark:text-gray-600 inline-flex items-center">
			<svg height={20} width={20}>
				<polygon
					transform="translate(4,4.5)"
					points={getDownwardEquilateralTrianglePoints()}
					fill="white"
					stroke="#AF1623"
					strokeWidth="1.5"
				/>
			</svg>
			{text}
		</span>
	);
};
const Trade = ({ text }: { text: string }) => {
	return (
		<span className="ms-2 text-xs md:text-sm font-semibold text-gray-600 dark:text-gray-600 inline-flex items-center">
			<svg height={15} width={15} className="" fill="none">
				<g transform="translate(0,2)">
					<rect x="2" y="2" width="6" height="6" stroke="#4c5564" />
					<rect x="3.5" y="3.5" width="3" height="3" fill="#4c5564" />
				</g>
			</svg>
			{text}
		</span>
	);
};
const DashedLine = ({ text }: { text: string }) => {
	return (
		<span className="text-xs md:text-sm font-semibold text-gray-600 dark:text-gray-600 inline-flex items-center gap-2">
			<svg height={2} width={21} fill="none">
				<line
					y1="1"
					x2="21"
					y2="1"
					stroke="#4B5563"
					strokeWidth="1.5"
					strokeDasharray="2.5 5 5 5"
				/>
			</svg>

			{text}
		</span>
	);
};

const AskRefCircle = ({ text }: { text: string }) => {
	return (
		<span className="text-xs md:text-sm font-semibold text-gray-600 dark:text-gray-600 inline-flex items-center gap-2">
			<svg height={20} width={32}>
				<line
					y1="10"
					x1="0"
					x2="28"
					y2="10"
					stroke="#175963"
					strokeWidth="2.5"
					strokeDasharray="4 4"
				/>
				<circle
					cy={10}
					cx={14}
					r={2.5}
					fill="white"
					stroke={"#175963"}
					strokeWidth="2"
				/>
			</svg>
			{text}
		</span>
	);
};
